import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import Report from '@/views/Report'
import Table from '@/views/Table'
import Student from '@/views/Student'
import Datas from '@/views/Datas'
import AddStudent from '@/views/AddStudent'
import Evalua from '@/views/Evalua'
import History from '@/views/History'
import Mystudents from '@/views/Mystudents'
import Waitevalua from '@/views/Waitevalua'
import Waitreport from '@/views/Waitreport'
import Assesscomp from '@/views/Assesscomp'
import Track from '@/views/Track'
import Previewreport from '@/views/Previewreport'
import Previewreporthtml from '@/views/PreviewreportHtml'
import Myself from '@/views/Myself'
import Setplan from '@/views/Setplan.vue'
import EvaluaHistory from '@/views/EvaluaHistory.vue'


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: { title: '登录' }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { title: '我的测评' }
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      meta: { title: '我的测评' }
    },
    {
      path: '/table',
      name: 'table',
      component: Table,
      meta: { title: '测评表格' }
    },
    {
      path: '/student',
      name: 'student',
      component: Student,
      meta: { title: '我的学员' }
    },
    {
      path: '/datas',
      name: 'datas',
      component: Datas,
      meta: { title: '我的学员' }
    },
    {
      path: '/addstudy',
      name: 'addstudy',
      component: AddStudent,
      meta: { title: '新增学员' }
    },
    {
      path: '/evalua',
      name: 'evalua',
      component: Evalua,
      meta: { title: '测评过程' }
    },
    {
      path: '/history',
      name: 'history',
      component: History,
      meta: { title: '所有测评' }
    },
    {
      path: '/mystudents',
      name: 'mystudents',
      component: Mystudents,
      meta: { title: '我的学员' }
    },
    {
      path: '/waitevalua',
      name: 'waitevalua',
      component: Waitevalua,
      meta: { title: '等待测评' }
    },
    {
      path: '/waitreport',
      name: 'waitreport',
      component: Waitreport,
      meta: { title: '等待报告' }
    },
    {
      path: '/assesscomp',
      name: 'assesscomp',
      component: Assesscomp,
      meta: { title: '测评完成' }
    },
    {
      path: '/track',
      name: 'track',
      component: Track,
      meta: { title: '跟踪列表' }
    },
    {
      path: '/previewreport',
      name: 'previewreport',
      component: Previewreport,
      meta: { title: '预览报告2' }
    },
    {
      path: '/previewreporthtml',
      name: 'previewreporthtml',
      component: Previewreporthtml,
      meta: { title: '预览报告' }
    },
    {
      path: '/myself',
      name: 'myself',
      component: Myself,
      meta: { title: '我的资料' }
    },
    {
      path: '/setplan',
      name: 'setplan',
      component: Setplan,
      meta: { title: '调整粗动作方案' }
    },
    {
      path: '/evaluahistory',
      name: 'evaluahistory',
      component: EvaluaHistory,
      meta: { title: '测评历史' }
    }
  ]
})
// 添加导航守卫，用于动态设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '默认标题'
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js